import { useSelector } from "react-redux";

import { usePageActions } from "store/PageSlice";

const usePage = () => {
  const { loadCategoryPage, loadPage, resetPage } = usePageActions();

  const { page } = useSelector((state) => state.PageSlice);

  return {
    loadCategoryPage,
    loadPage,
    page,
    resetPage,
  };
};

export default usePage;
